import { Dashboard, Logout } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import { Badge } from "@mui/material";
import { useSelector } from "react-redux";
import menuConfig from "../../../config/MenuConfig";


const Sidebar = ({ collapsed, onLogout, user }) => {

  const pendingOrdersCount = useSelector(
    (state) =>
      state.employeeOrders.orders?.response?.filter(
        (order) => order.orderStatus === "PENDING" && order?.customSizes.length === 0
      ).length || 0
  );
  const pendingCustomSizeOrdersCount = useSelector(
    (state) =>
      state.employeeOrders.orders?.response?.filter(
        (order) => order.orderStatus === "PENDING" && order?.customSizes.length !== 0
      ).length || 0
  );

  const transferPaymentsCount = useSelector((state) => {
    const payments = state.vendorPayments.payments?.response || [];

    const now = new Date();

    return payments.filter((payment) => {
      if (
        payment.order?.orderStatus !== "DELIVERED" ||
        payment.adminPaymentStatus !== "TRANSFER" ||
        !payment.transferDate
      ) {
        return false;
      }

      const transferDate = new Date(payment.transferDate);
      const diffInDays =
        (now.getTime() - transferDate.getTime()) / (1000 * 60 * 60 * 24);

      // ✅ sirf 2 din tak count
      return diffInDays <= 2;
    }).length;
  });

  return <aside className={`bg-white shadow-md h-full flex flex-col transition-all duration-300 ${collapsed ? "w-16" : "w-64"}`}>
    {/* Top Header Section */}
    <div className="p-4 text-xl font-bold flex items-center justify-center justify-content-center gap-2 border-b" style={{ fontFamily: "Greycliff CF" }}>
      <Dashboard className="text-[#449AEF]" />
      {!collapsed && "SELLER"}
    </div>

    {/* Scrollable Menu Section */}
    <div className="flex-1 overflow-y-auto">
      <nav className="flex flex-col p-2">
        {menuConfig
          .filter(item => item.category === "Vendor")
          .map(({ name, path, icon: Icon }) => (
            <NavLink
              key={path}
              to={path}
              end
              className={({ isActive }) =>
                `flex items-center p-1 mt-1 mb-1 rounded no-underline 
                        hover:bg-[#449AEF] hover:text-white 
                        ${isActive ? "bg-[#449AEF] font-bold text-white" : ""}`
              }
              style={{ textDecoration: "none", fontFamily: "Greycliff CF" }}
            >
              {(name === "Orders" && pendingOrdersCount !== 0) ? (

                <Badge
                  className={({ isActive }) =>
                    `hover:bg-[#449AEF] hover:text-white ${isActive ? "bg-[#449AEF] font-bold text-white" : ""
                    }`
                  }
                  badgeContent={pendingOrdersCount}
                  color="error"
                  overlap="rectangular"
                >
                  <Icon className="h-5 w-5 me-2" />
                </Badge>
              ) : (name === "Orders With Custom Size" && pendingCustomSizeOrdersCount !== 0) ? (
                <Badge
                  className={({ isActive }) =>
                    `hover:bg-[#449AEF] hover:text-white ${isActive ? "bg-[#449AEF] font-bold text-white" : ""
                    }`
                  }
                  badgeContent={pendingCustomSizeOrdersCount}
                  color="error"
                  overlap="rectangular"
                >
                  <Icon className="h-5 w-5 me-2" />
                </Badge>
              ) : (name === "Payments" && transferPaymentsCount) ? (
                <Badge
                  className={({ isActive }) =>
                    `hover:bg-[#449AEF] hover:text-white ${isActive ? "bg-[#449AEF] font-bold text-white" : ""
                    }`
                  }
                  badgeContent={transferPaymentsCount}
                  color="error"
                  overlap="rectangular"
                >
                  <Icon className="h-5 w-5 me-2" />
                </Badge>
              ) : (
                <Icon className="h-5 w-5 me-2" />
              )}

              {!collapsed && (
                <>
                  {name}
                </>
              )}
            </NavLink>
          ))}
      </nav>
    </div>

    {/* Bottom User Section */}
    <div className="p-1 border-t mb-1">
      {!collapsed ? (
        <div className="flex items-center justify-between w-full">
          {/* Left side - Avatar + Name + Email */}
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-full bg-[#449AEF] text-white flex items-center justify-center text-md font-bold uppercase">
              {user?.name?.charAt(0) || "S"}
            </div>
            <div>
              <div className="font-medium truncate max-w-[120px]">{user?.name || "Seller"}</div>
              <div className="text-gray-500 text-sm truncate max-w-[160px]">
                {user?.email || "seller@gmail.com"}
              </div>
            </div>
          </div>

          {/* Right side - Logout Button */}
          <button
            onClick={onLogout}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
            title="Logout"
          >
            <Logout className="text-gray-700 hover:text-[#449AEF]" />
          </button>
        </div>
      ) : (
        <div className="flex justify-center">
          <button
            onClick={onLogout}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
            title="Logout"
          >
            <Logout className="text-gray-700 hover:text-[#449AEF]" />
          </button>
        </div>
      )}
    </div>
  </aside>;
};

export default Sidebar;
